// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4da89a61","513":"f65a764a","703":"a909aa2e","787":"fea71595"}[chunkId] + ".chunk.js";
};